import React from 'react';
import styled from 'styled-components';
import {hover, text, title, title_ms60} from "../styles/globalStyleVars";
import ReactHtmlParser from "react-html-parser";
import reactHtmlParser from "react-html-parser";

const Title = ({
                   text,
                   fontSize,
                   fontWeight,
                   color,
                   letterSpacing,
                   lineHeight,
                   textTransform,
                   margin,
                   padding,
                   borderColor,
                   varient,
                   center,
                   classname,
                   small_text,
                    fontFamily,
                   nosplit
               }) => {


    return (

        <StyledTitle className={`title ${classname}`}
                     fontSize={fontSize}
                     fontWeight={fontWeight}
                     color={color}
                     lineHeight={lineHeight}
                     LetterSpacing={letterSpacing}
                     textTransform={textTransform}
                     margin={margin}
                     padding={padding}
                     varient={varient}
                     center={center}
                     borderColor={borderColor}
                     fontFamily={fontFamily}
                     nosplit={nosplit}
        >

            <h3 className={`${nosplit ? '' : 'split-up'}`}>{ReactHtmlParser(text)}</h3>


        </StyledTitle>

    )
};


const StyledTitle = styled.div`
  margin: ${props => props.margin || '0px'};
  position: relative;
  width: 100%;
  font-family: ${props => props.fontFamily || title};;
  text-align: ${props => props?.center ? 'center' : ''};
  padding: ${p => p.padding};

  h3 {
    font-size: ${props => props.fontSize || 40}px;
    line-height: ${props => props.lineHeight || 48}px;
    //text-transform: uppercase;
    font-weight: ${props => props.fontWeight || '400'};
    color: ${props => props.color || text};
    span{
      color: ${props => props.color || hover};

    }
  }


  @media (max-width: 767px) {
    margin-bottom: 40px !important;
    padding: 0;
    h3 {
      font-size: 24px !important;
      line-height: 32px !important;
    }
  }
`;


export default Title;














